import { Img } from 'react-image';
import { useLocation } from 'react-router-dom';
import { useThemeContext } from 'src/context/ThemeProvider';
import SignupWrapper from './SignupWrapper';
import SigninWrapper from './SigninWrapper';
import { useMediaQuery } from '@mui/material';
import RecruiterSideUsersSwiperComponent from './RecruiterSideUsersSwiperComponent';
import DemoWrapper from './DemoWrapper';
import classNames from 'classnames';

interface Props {
	bookADemo?: boolean;
}

const RecruiterAuthSideInfo = ({ bookADemo }: Props) => {
	const location = useLocation();
	const { themeMode } = useThemeContext();
	const isMobile = useMediaQuery('(max-width:960px)');
	const signInurl = location.pathname?.split('?')[0];

	const companyLogos = [
		'https://masai-website-images.s3.ap-south-1.amazonaws.com/dream11_b903dea469.png',
		'https://masai-website-images.s3.ap-south-1.amazonaws.com/airmeet_83893dfa48.png',
		'https://masai-website-images.s3.ap-south-1.amazonaws.com/vyapar_594dcdf476.png',
		'https://masai-website-images.s3.ap-south-1.amazonaws.com/swiggy_0a6e14c7ff.png',
		'https://masai-website-images.s3.ap-south-1.amazonaws.com/bharatpe_10c66230ef.png',
	];

	const pointersData = [
		{
			title: 'Pre-vetted Talent',
			icon: 'https://masai-website-images.s3.ap-south-1.amazonaws.com/recruiter_point_1_6e2066196d.png',
			description: 'Hire from an elite pool of candidates, handpicked through a rigorous vetting process.',
		},
		{
			title: 'Save Time & Resources',
			icon: 'https://masai-website-images.s3.ap-south-1.amazonaws.com/recruiter_point_2_b7d22d3288.png',
			description: 'Streamline your hiring with smart applicant sorting— no more endless resume screening.',
		},
		{
			title: 'AI-Driven Matching',
			icon: 'https://masai-website-images.s3.ap-south-1.amazonaws.com/recruiter_point_3_524c81543f.png',
			description: 'Leverage our AI-powered ATS to discover the best candidates effortlessly.',
		},
	];

	return (
		<div
			className={`w-[100%] overflow-hidden flex flex-col justify-between dark:bg-[#1f3343]  bg-[#F7F9FB] md:bg-[#FFF] relative isolate`}
		>
			<img
				alt=""
				className="absolute w-full h-full z-[-1]"
				src="https://masai-website-images.s3.ap-south-1.amazonaws.com/auth_bg_00f757f54a.png"
			/>
			{(signInurl === '/auth/signin' ||
				signInurl === '/auth/bookADemo' ||
				signInurl === '/auth/register' ||
				signInurl === '/auth/email-verification' ||
				signInurl === '/auth/phone-verification' ||
				signInurl === '/auth/change-phone' ||
				signInurl === '/auth/change-email') && (
				<div
					className={classNames(
						'flex flex-col md:min-h-[100dvh] overflow-auto',
						location?.pathname.includes('bookADemo') ? 'pb-[72px]' : '',
					)}
				>
					<div className="max-w-[90%] mx-[5%]">
						<Img
							loading="lazy"
							className={`block pt-[20px] pb-[18px] pl-[6px] ${bookADemo ? '' : 'md:hidden'}`}
							src={
								themeMode === 'dark'
									? 'https://masai-website-images.s3.ap-south-1.amazonaws.com/Levelup-Logo.png'
									: 'https://masai-website-images.s3.ap-south-1.amazonaws.com/Levelup-Logo.png'
							}
							width={bookADemo && !isMobile ? '142' : '101'}
							height={bookADemo && !isMobile ? '48' : '36'}
							alt="logo"
						/>

						<div
							className={`text-[32px] md:text-[54px] font-inter font-[700] dark:text-[#fff] !text-[#1F3343] leading-[40px] md:leading-[56px]  ${
								!bookADemo ? 'md:mt-[50px]' : 'md:mt-[20px]'
							}`}
						>
							<span className="inline-flex greenish-gradient-text bg-clip-text text-transparent">
								Pre-vetted talent
							</span>{' '}
							handpicked for you, at Zero cost
							<span className="text-[24px] leading-0 relative top-[-10px] md:top-[-24px] text-[#555770]">*</span>
						</div>
						<div className="mt-4 md:mt-6 text-base font-[500] text-[#555770]">
							In search of exceptional, vetted tech professionals? We've got you covered.
						</div>

						<div className="flex items-center justify-between pt-3">
							<div className="flex flex-col gap-4 md:gap-8 xl:pl-8 py-4 md:py-8 max-w-[584px]">
								{pointersData.map((pointer, index) => (
									<div key={index} className="flex items-start gap-2 md:gap-4">
										<img
											className="min-w-[34px] md:min-w-[48px] min-h-[34px] md:min-h-[48px] w-[34px] md:w-[48px] h-[34px] md:h-[48px]"
											src={pointer.icon}
											alt={pointer.title}
										/>
										<div>
											<h3 className="text-sm md:text-lg font-inter font-[700] text-[#28293D]">{pointer.title}</h3>
											<p className="text-xs md:text-sm font-inter font-[500] text-[#555770]">{pointer.description}</p>
										</div>
									</div>
								))}
							</div>

							{!bookADemo && <RecruiterSideUsersSwiperComponent />}
						</div>

						<div
							className={classNames(
								`md:hidden ${bookADemo ? 'mt-[30px]' : 'mx-[-16px]'}`,
								location?.pathname.includes('bookADemo')
									? 'fixed inset-x-0 bottom-0 z-[1] shadow-[0px_-2px_4px_0px_rgba(0,_0,_0,_0.15)]'
									: '',
							)}
						>
							{location?.pathname.includes('register') ? (
								<SignupWrapper showFormUiOnly={true} />
							) : location?.pathname.includes('bookADemo') ? (
								<DemoWrapper />
							) : (
								<SigninWrapper showFormUiOnly={true} />
							)}
						</div>

						<div className="relative m-auto py-4 mt-3 text-center md:text-left md:mt-[30px] box-border flex flex-col gap-7 overflow-hidden">
							<div>2000+ companies trust LevelUp for hiring tech talent</div>
							<div className="flex flex-wrap justify-center md:justify-evenly gap-3">
								{companyLogos?.map(el => <Img key={el} src={el} className="max-w-[94px]" />)}
							</div>
						</div>

						<div className="text-sm text-[#555770] text-left mt-4 pb-2">*90 days of free trial access to Placed.</div>
					</div>
				</div>
			)}
		</div>
	);
};

export default RecruiterAuthSideInfo;
